<template>
  <div class="box">
    <img
      v-if="offer.couponDetailsImageUrl"
      class="image box__header-image"
      :src="offer.couponDetailsImageUrl"
    >

    <div class="layout layout--horizontal half-spacing">
      <h3 class="title title--4 bold grow no-spacing">{{ offer.title }}</h3>
      <span
        v-if="offer.webRedemptionUrl"
        class="icon icon--bigger fa-stars primary"
      />
      <span
        v-else
        class="icon icon--bigger far fa-gift primary"
      />
    </div>

    <p class="dark half-spacing content">{{ offer.description }}</p>

    <button
      v-if="startOrderFromOfferEnabled"
      type="button"
      class="button button--primary"
      @click="startOrderClickHandler"
    >
      {{ startOrderContent }}
    </button>

    <button
      v-if="isInStoreRedeemButtonVisible"
      type="button"
      class="button button--primary"
      :disabled="isDisabled"
      @click="redeemOfferClickHandler"
    >
      {{ inStoreRedemptionButtonText }}
    </button>

    <a
      v-if="isWebRedeemButtonVisible"
      class="button button--primary"
      :href="offer.webRedemptionUrl"
      target="_blank"
    >
      {{ content.Loyalty.metadata.buttonCta }}
    </a>

    <div class="layout layout--horizontal">
      <p v-if="offer.endDate">Expires {{ $formatDate(offer.endDate) }}</p>

      <a
        v-if="offer.finePrintUrl"
        class="link link--margin primary"
        :href="offer.finePrintUrl"
        target="_blank"
      >
        Terms & Conditions
      </a>

      <button
        v-else
        class="link link--margin primary"
        type="button"
        @click="termsAndConditionsClickHandler"
      >
        Terms & Conditions
      </button>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'OfferSummaryCard',

    props: {
      offer: {
        type: Object,
        required: true
      },

      isOfferDisabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('session', ['currentUser']),
      ...mapGetters('merchant', ['isOfferInStoreRedemptionEnabled', 'startOrderFromOfferEnabled']),

      isInStoreRedeemButtonVisible() {
        return this.isOfferInStoreRedemptionEnabled && this.offer.redemptionChannels.includes('PosIntegratedAppRedemptionCode');
      },

      isWebRedeemButtonVisible() {
        return !!this.offer.webRedemptionUrl && this.offer.redemptionChannels.includes('WebUrl');
      },

      inStoreRedemptionButtonText() {
        return this.content?.Loyalty?.metadata?.availableOfferInStoreRedemptionCta || 'Redeem In Store';
      },

      isDisabled() {
        /** this.isOfferDisabled acts as an override */
        return this.isOfferDisabled || !this.currentUser.allowInStoreOfferRedemption;
      },

      startOrderContent() {
        return this.content.LoyaltyOfferRedemption.metadata.startMobileOrderCta;
      }
    },

    methods: {
      startOrderClickHandler() {
        const routerPayload = { name: 'orderMenu', params: { merchantId: this.$route.params.merchantId } };

        this.$router.push(routerPayload);
      },

      redeemOfferClickHandler() {
        const modalPayload = { offer: this.offer };

        this.$openModal('offerInStoreRedemption', modalPayload);
      },

      termsAndConditionsClickHandler() {
        const modalPayload = { offer: this.offer };

        this.$openModal('offerTermsAndConditions', modalPayload);
      }
    }
  };
</script>
